import { Divider } from "antd";
import React from "react";
import CustomDatePicker from "../../../../../components/common/DatePicker/CustomDatePicker";
import CustomTable from "../../../../../components/common/Table/CustomTable";
import TextInput from "../../../../../components/common/TextInput/TextInput";
import { CurrencyFormat } from "../../../../../components/helpers";
import { renderListAgentColumns } from "../constants";

export default function ListReferralAgent(props) {
  return (
    <div>
      <div className="d-flex filter-bar filter-bar-2">
        <TextInput
          id={"pageSize"}
          label={"Tampilkan"}
          width={60}
          handleEnter={props.handleEnter}
          value={props.filterInput.pageSize}
          handleChange={props.handleInputChange}
        />
        <TextInput
          id={"search"}
          placeholder="Cari..."
          label={"Nama Nasabah"}
          width={350}
          handleEnter={props.handleEnter}
          value={props.filterInput.search}
          handleChange={props.handleInputChange}
        />
        <div>
          <CustomDatePicker
            id={"date"}
            label={"Tanggal"}
            isRangePicker
            width={300}
            onInputChange={props.handleDateChange}
            height="35px"
          />
        </div>
      </div>
      <div className="d-flex total-outer-container my-3">
        <div className="col-6 align-items-center center">
          <div className="total-value text-center" style={{ color: "#2C465C" }}>
            Rp{" "}
            {CurrencyFormat(props.commissionMasterData?.totalCommission) || 0}
          </div>
          <div className="total-label text-center">Total Komisi</div>
        </div>
        <Divider className="total-divider" type="vertical" />
        <div className="col-6 text-center">
          <div className="total-value text-center" style={{ color: "#F23434" }}>
            Rp{" "}
            {CurrencyFormat(
              props.commissionMasterData?.notYetDisbursedTotalCommission
            ) || 0}
          </div>
          <div className="total-label">Belum Dicairkan</div>
        </div>
      </div>
      <CustomTable
        columns={renderListAgentColumns(props.handleProcessButton)}
        data={props.data}
        loading={props.loading}
        handleTableChange={props.handleTableChange}
        pagination={props.tablePagination}
      />
    </div>
  );
}
